/* eslint-disable import/no-duplicates */
import { ReactElement } from 'react';
import { Input } from 'components';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from 'helpers/capitalizeFirstLetter';
import { format, parseISO } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import enUS from 'date-fns/locale/en-US';
import i18n from 'i18n';
import createNumberMask from 'helpers/maskInputs';
import { Controller, useFormContext } from 'react-hook-form';
import { InfoIconCR } from '~/icons';
import { MeasureUnitIndicatorContainer, MonthInputContainer } from './styles';

interface MonthInputProps {
  name: string;
  label: string;
  disabled?: boolean;
  updatedAt?: string;
  isPast?: boolean;
  onChange?: (value: string) => void;
}

function MeasureUnitIndicator(): ReactElement {
  return (
    <MeasureUnitIndicatorContainer>
      <span>kWh</span>
    </MeasureUnitIndicatorContainer>
  );
}

export function MonthInput({
  name,
  label,
  updatedAt,
  disabled,
  isPast,
  onChange,
}: Readonly<MonthInputProps>): ReactElement {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <MonthInputContainer>
      <div>
        <Controller
          control={control}
          name={name}
          render={({
            field: {
              onChange: onFieldChange, onBlur, value,
            }, fieldState,
          }) => (
            <Input
              label={label}
              placeholder={t('digiteAMeta')}
              mask={createNumberMask({
                allowDecimal: true,
                integerLimit: 8,
                decimalLimit: 2,
                decimalSymbol: i18n.language === 'pt' ? ',' : '.',
                thousandsSeparatorSymbol: i18n.language === 'pt' ? '.' : ',',
              })}
              style={{ width: '150px' }}
              icon={isPast ? {
                iconElement: <InfoIconCR />,
                placement: 'end',
              } : undefined}
              onInput={(event) => {
                onFieldChange(event);
                if (onChange) {
                  onChange((event.target as HTMLInputElement).value);
                }
              }}
              onBlur={onBlur}
              value={value}
              error={fieldState.error?.message}
              disabled={disabled}
            />
          )}
        />
        <MeasureUnitIndicator />
      </div>
      {updatedAt && (
        <span>
          {`${t('lancadaEm')} ${capitalizeFirstLetter(format(parseISO(updatedAt), 'MMM/y', {
            locale: i18n.language === 'pt' ? ptBR : enUS,
          }))}`}
        </span>
      )}
    </MonthInputContainer>
  );
}
